import timg1 from '../images/team/dr-eugene-pereira.jpg'
import timg2 from '../images/team/2.png'
import timg3 from '../images/team/3.png'
import timg4 from '../images/team/4.png'
import timg5 from '../images/team/5.png'
import timg6 from '../images/team/6.png'



import Stime1 from '../images/team/dr-eugene-pereira.jpg'
import Stime2 from '../images/team-single/2.jpg'
import Stime3 from '../images/team-single/3.jpg'
import Stime4 from '../images/team-single/4.jpg'
import Stime5 from '../images/team-single/5.jpg'
import Stime6 from '../images/team-single/6.jpg'



const Teams = [
    {
        id: '1',
        title: 'Dr. Eugene G. Pereira, MD',
        subtitle: 'Medical Director • ABA-PM • FIPP • ABIPP • Licensed: FL, NY, NJ, UT',
        slug: 'dr-eugene-pereira',
        timg: timg1,
        Sime: Stime1,
    },
    {
        id: '2',
        title: 'Regenerative Medicine Team',
        subtitle: 'Stem Cell Processing Specialists',
        slug: 'regenerative-medicine-team',
        timg: timg2,
        Sime: Stime2,
    },
    {
        id: '3',
        title: 'Clinical Nursing Staff',
        subtitle: 'Certified Regenerative Nurses',
        slug: 'clinical-nursing-staff',
        timg: timg3,
        Sime: Stime3,
    },
    {
        id: '4',
        title: 'Pain Management Team',
        subtitle: 'Interventional Pain Specialists',
        slug: 'pain-management-team',
        timg: timg4,
        Sime: Stime4,
    },
    {
        id: '5',
        title: 'Patient Care Coordinators',
        subtitle: 'Your Journey Support Team',
        slug: 'patient-care-coordinators',
        timg: timg5,
        Sime: Stime5,
    },
    {
        id: '6',
        title: 'Medical Support Staff',
        subtitle: 'Diagnostic & Imaging Specialists',
        slug: 'medical-support-staff',
        timg: timg6,
        Sime: Stime6,
    },


]

export default Teams;



